import { GlDropdownItem } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { MountingPortal } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/portal_vue_vue3.js?vue3';
import { s__ } from '~/locale';
import AbuseCategorySelector from '/builds/gitlab/gitlab-ee/app/assets/javascripts/abuse_reports/components/abuse_category_selector.vue?vue3';
export default {
    name: 'ReportAbuseDropdownItem',
    components: {
        GlDropdownItem,
        MountingPortal,
        AbuseCategorySelector
    },
    inject: [
        'reportedUserId',
        'reportedFromUrl'
    ],
    i18n: {
        reportAbuse: s__('ReportAbuse|Report abuse')
    },
    data () {
        return {
            open: false
        };
    },
    methods: {
        toggleDrawer (open) {
            this.open = open;
        }
    }
};
